import {
  Dribbble,
  Facebook,
  FormerlyKnownAsTwitter,
  GitHub,
  Instagram,
  LinkedIn,
} from '@/client/components/icons/ContinuIcons';
import { HStack, Link, Stack, Text } from '@chakra-ui/react';

import type { User as UserType } from '@/client/types/User';
import { useTranslation } from 'react-i18next';

interface SocialProfilesSectionProps {
  userData: UserType;
}

export default function SocialProfilesSection({ userData }: SocialProfilesSectionProps) {
  const { t } = useTranslation();
  const { social_links: socialLinks } = userData;

  const iconMap: Record<string, React.ReactNode> = {
    linkedin: <LinkedIn />,
    facebook: <Facebook />,
    instagram: <Instagram />,
    twitter: <FormerlyKnownAsTwitter />,
    github: <GitHub />,
    dribbble: <Dribbble />,
  };

  return socialLinks.length > 0 ? (
    <Stack spacing={2}>
      {socialLinks.map((link) => (
        <HStack key={link.name} spacing={2}>
          {iconMap[link.name]}

          <Link
            fontSize="16px"
            fontWeight={400}
            color="baseBlack"
            href={link.value}
            isExternal
            _hover={{ textDecoration: 'underline', color: 'baseBlack' }}
          >
            {link.value}
          </Link>
        </HStack>
      ))}
    </Stack>
  ) : (
    <Text fontSize="16px" fontWeight={400} textDecoration="italic" color="neutral.800">
      {t('learners.profile.userDetails.noSocialProfiles')}
    </Text>
  );
}
